import React from 'react';
import { View } from 'react-native';
import Svg, { ClipPath, G, Defs, Path, Rect } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const MagnifyingGlass = ({
  color = colors.primary,
  size = 28,
  style,
  ...props
}: IconProps) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 28 28"
          fill="none"
          style={style as React.CSSProperties}
        >
          <g clipPath="url(#clip0_4803_5070)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.7702 18.3695C22.3572 16.3234 23.1052 13.7495 22.8619 11.1715C22.6186 8.5935 21.4023 6.20502 19.4605 4.49197C17.5186 2.77891 14.9971 1.86998 12.4089 1.95007C9.82068 2.03016 7.36018 3.09326 5.52798 4.9231C3.69418 6.7542 2.6276 9.21565 2.54559 11.8058C2.46359 14.396 3.37233 16.92 5.08663 18.8634C6.80093 20.8069 9.19177 22.0235 11.7719 22.2654C14.3521 22.5073 16.9274 21.7562 18.9731 20.1653L19.0278 20.2226L24.4267 25.6227C24.545 25.741 24.6853 25.8348 24.8398 25.8988C24.9943 25.9628 25.1599 25.9957 25.3272 25.9957C25.4944 25.9957 25.66 25.9628 25.8145 25.8988C25.969 25.8348 26.1094 25.741 26.2276 25.6227C26.3459 25.5045 26.4397 25.3641 26.5037 25.2096C26.5677 25.0551 26.6006 24.8895 26.6006 24.7223C26.6006 24.555 26.5677 24.3895 26.5037 24.235C26.4397 24.0805 26.3459 23.9401 26.2276 23.8218L20.8274 18.4229L20.7702 18.3695ZM18.128 6.72401C18.8466 7.43098 19.4181 8.27323 19.8095 9.20218C20.201 10.1311 20.4046 11.1284 20.4087 12.1364C20.4128 13.1445 20.2173 14.1434 19.8334 15.0755C19.4496 16.0076 18.8849 16.8544 18.1721 17.5673C17.4593 18.2801 16.6124 18.8447 15.6803 19.2285C14.7482 19.6124 13.7494 19.8079 12.7413 19.8038C11.7333 19.7997 10.736 19.5961 9.80706 19.2046C8.87811 18.8132 8.03586 18.2417 7.32889 17.5231C5.91606 16.0871 5.1279 14.1509 5.13611 12.1364C5.14431 10.1219 5.9482 8.19228 7.37268 6.7678C8.79716 5.34332 10.7268 4.53943 12.7413 4.53123C14.7558 4.52302 16.6919 5.31118 18.128 6.72401Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_4803_5070">
              <rect width={size} height={size} fill="none" />
            </clipPath>
          </defs>
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      style={style}
      {...props}
    >
      <G clipPath="url(#clip0_4803_5070)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7702 18.3695C22.3572 16.3234 23.1052 13.7495 22.8619 11.1715C22.6186 8.5935 21.4023 6.20502 19.4605 4.49197C17.5186 2.77891 14.9971 1.86998 12.4089 1.95007C9.82068 2.03016 7.36018 3.09326 5.52798 4.9231C3.69418 6.7542 2.6276 9.21565 2.54559 11.8058C2.46359 14.396 3.37233 16.92 5.08663 18.8634C6.80093 20.8069 9.19177 22.0235 11.7719 22.2654C14.3521 22.5073 16.9274 21.7562 18.9731 20.1653L19.0278 20.2226L24.4267 25.6227C24.545 25.741 24.6853 25.8348 24.8398 25.8988C24.9943 25.9628 25.1599 25.9957 25.3272 25.9957C25.4944 25.9957 25.66 25.9628 25.8145 25.8988C25.969 25.8348 26.1094 25.741 26.2276 25.6227C26.3459 25.5045 26.4397 25.3641 26.5037 25.2096C26.5677 25.0551 26.6006 24.8895 26.6006 24.7223C26.6006 24.555 26.5677 24.3895 26.5037 24.235C26.4397 24.0805 26.3459 23.9401 26.2276 23.8218L20.8274 18.4229L20.7702 18.3695ZM18.128 6.72401C18.8466 7.43098 19.4181 8.27323 19.8095 9.20218C20.201 10.1311 20.4046 11.1284 20.4087 12.1364C20.4128 13.1445 20.2173 14.1434 19.8334 15.0755C19.4496 16.0076 18.8849 16.8544 18.1721 17.5673C17.4593 18.2801 16.6124 18.8447 15.6803 19.2285C14.7482 19.6124 13.7494 19.8079 12.7413 19.8038C11.7333 19.7997 10.736 19.5961 9.80706 19.2046C8.87811 18.8132 8.03586 18.2417 7.32889 17.5231C5.91606 16.0871 5.1279 14.1509 5.13611 12.1364C5.14431 10.1219 5.9482 8.19228 7.37268 6.7678C8.79716 5.34332 10.7268 4.53943 12.7413 4.53123C14.7558 4.52302 16.6919 5.31118 18.128 6.72401Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_4803_5070">
          <Rect width={size} height={size} fill="none" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
